const teamsTestIDs = {
  teamsScreen: 'teams-screen',
};

export default teamsTestIDs;
